import type { HistoryView } from '@/components/History/HistoryPanels';

import { routes } from '@/utils/routes';

/** A tab on /profile: the portfolio or one trade-history pane. */
export type ProfileView = 'portfolio' | HistoryView;

/** Path segments after /profile that address each view. */
const PROFILE_SEGMENTS: Record<ProfileView, string[]> = {
  'portfolio': [],
  'swaps': ['history'],
  'limit-orders': ['history', 'advanced'],
  'open-orders': ['open-orders'],
};

export const profileRoute = (view: ProfileView) => {
  const tab = PROFILE_SEGMENTS[view];
  // An empty catch-all would leave a trailing slash on /profile.
  const query: Record<string, string[]> = tab.length ? { tab } : {};
  return { pathname: routes.PROFILE, query };
};

/** The view addressed by /profile's path segments, undefined when none matches. */
export const parseProfileView = (
  segments: string | string[] | undefined,
): ProfileView | undefined => {
  const path = [segments ?? []].flat().join('/');
  return (Object.keys(PROFILE_SEGMENTS) as ProfileView[]).find(
    (view) => PROFILE_SEGMENTS[view].join('/') === path,
  );
};
